import React from "react"

const BottomBlurCircle = () => {
  return (
    <svg
      style={{ position: "absolute", bottom: "0px", left: "57px" }}
      xmlns="http://www.w3.org/2000/svg"
      width="213"
      height="121"
      viewBox="0 0 213 121"
      fill="none"
    >
      <g opacity="0.2" filter="url(#filter0_f_40008171_395)">
        <circle
          cx="106.5"
          cy="106.5"
          r="56.5"
          fill="#31A5C4"
          fillOpacity="0.6"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_40008171_395"
          x="0"
          y="0"
          width="213"
          height="213"
          filterUnits="userSpaceOnUse"
          colorInterpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="25"
            result="effect1_foregroundBlur_40008171_395"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default BottomBlurCircle
